"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withCreateFilter = exports.Layout = exports.Header = exports.Bottom = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactI18next = require("react-i18next");
var _Button = _interopRequireDefault(require("../../components/Button"));
var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));
var _HelpOutline = _interopRequireDefault(require("@material-ui/icons/HelpOutline"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _MenuList = _interopRequireDefault(require("@material-ui/core/MenuList"));
var _Tooltip = _interopRequireDefault(require("../../components/Tooltip"));
var _excluded = ["onClick", "cleanupType", "action"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Layout = exports.Layout = function Layout(_ref) {
  var header = _ref.header,
    bottom = _ref.bottom,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-screen w-full flex flex-col px-4",
    style: {
      paddingBottom: 90
    }
  }, header, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow"
  }, children), bottom);
};
var Header = exports.Header = function Header() {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-5xl font-bold text-dark py-2 flex-shrink-0"
  }, t('cleanup.calendar.detail.title'));
};
var withCreateFilter = exports.withCreateFilter = function withCreateFilter(Component) {
  return function (_ref2) {
    var _onClick = _ref2.onClick,
      cleanupType = _ref2.cleanupType,
      action = _ref2.action,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
    var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;
    var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];
    var checkedRef = (0, _react.useRef)(false);
    var toggle = function toggle() {
      return setOpen(function (open) {
        return !open;
      });
    };
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Component, _objectSpread(_objectSpread({}, rest), {}, {
      onClick: function onClick() {
        return setOpen(true);
      }
    })), /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
      size: "md",
      fullWidth: true,
      open: isOpen,
      onClose: toggle
    }, /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], null, t('cleanup.warning.title')), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "font-semibold text-dark"
    }, t("cleanup.warning.description.".concat(action))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center mt-2"
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "select-none inline-flex items-center"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      type: "checkbox",
      className: "w-4 h-4",
      defaultChecked: checkedRef.current,
      onChange: function onChange() {
        return checkedRef.current = !checkedRef.current;
      },
      autoFocus: true
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: " text-sm text-gray-light ml-2"
    }, t('cleanup.calendar.automatilly'))), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
      title: t('cleanup.calendar.automatilly.help', {
        cleanupType: cleanupType
      })
    }, /*#__PURE__*/_react["default"].createElement(_HelpOutline["default"], {
      fontSize: "small",
      className: "text-gray-light ml-2"
    })))), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      color: "white",
      size: "sm",
      className: "w-24",
      onClick: toggle
    }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      className: "ml-4 w-24",
      size: "sm",
      onClick: function onClick() {
        _onClick(checkedRef.current);
        toggle();
      }
    }, t('button.okay')))));
  };
};
var CreateFilterButton = withCreateFilter(_Button["default"]);
var CreateFilterMenuItem = withCreateFilter(_MenuItem["default"]);
var Bottom = exports.Bottom = function Bottom(_ref3) {
  var disabled = _ref3.disabled,
    actions = _ref3.actions,
    onAction = _ref3.onAction,
    onIgnore = _ref3.onIgnore,
    cleanupType = _ref3.cleanupType,
    className = _ref3.className,
    style = _ref3.style;
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var anchorRef = (0, _react.useRef)();
  var handleToggle = function handleToggle() {
    return setOpen(function (value) {
      return !value;
    });
  };
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex flex-1 pl-12 min-w-0 my-4', className),
    style: _objectSpread({}, style)
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "secondary",
    disabled: disabled,
    style: {
      width: 250
    },
    onClick: function onClick() {
      return onIgnore();
    }
  }, t('button.ignore')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "inline-flex ml-4",
    ref: anchorRef,
    style: {
      width: 250
    }
  }, /*#__PURE__*/_react["default"].createElement(CreateFilterButton, {
    onClick: function onClick(createFilter) {
      return onAction(actions[0], createFilter);
    },
    disabled: disabled,
    action: actions[0],
    className: "flex-grow",
    cleanupType: cleanupType
  }, actions[0]), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: handleToggle,
    className: (0, _classnames["default"])({
      'bg-primary-active': open
    })
  }, /*#__PURE__*/_react["default"].createElement(_ArrowDropDown["default"], null))), /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    open: open,
    anchorEl: anchorRef.current,
    elevation: 2,
    onClose: handleToggle,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_MenuList["default"], {
    style: {
      width: 250
    }
  }, actions.slice(1).map(function (action) {
    return /*#__PURE__*/_react["default"].createElement(CreateFilterMenuItem, {
      disabled: disabled,
      key: action,
      action: action,
      cleanupType: cleanupType,
      onClick: function onClick(createFilter) {
        return onAction(action, createFilter);
      },
      disableRipple: true
    }, action);
  })))));
};
//# sourceMappingURL=Calendar.js.map